
import ModalView from 'common-views/ModalView';
import template  from 'dashboard/permissions-modal.ejs';
import util from 'util/Util.js';
import constants from 'Constants';

import { Model } from 'backbone';

import PermissionsDetailView from 'dashboard/forms/PermissionsDetailView';
import SelectItemModalView  from 'common-views/SelectItemModalView.js'

import restService from 'RestService';
import restMessages from 'RestMessages';

import Spinner from 'spin/spin';


class PermissionsModal extends ModalView {

    initialize(){
        super.initialize();
        this.template = template;
        this.Spinner = new Spinner();

    }

    bindEvents(){
        const self = this;

        $("#addPermissionForm").on("click", (ev) =>{
            this.addPermission(ev);
        });
        $("#removePermissionForm").on("click", (ev) =>{
            this.removePermission(ev);
        });

        $(`select[name='permissions']`).off().on('change', (ev) => {

            const $el = $(ev.currentTarget);
            const
                isReport = false,
                selectedUser = $el.val() || "",
                selectedUserId = $el.children(':selected').attr('id'),
                fullControlIdPrefix = constants.FORMS_FULL_CONTROL_PERM_DATA_INDEX;

                this.model.set( {
                    'selectedViewer': selectedUser,
                    'selectedViewerId': selectedUserId
                }, {silent: true});


            const permission = PermissionsDetailView.selectedViewerPerms(selectedUserId, selectedUser, self.model.get('currentPermissionList'));
            self.model.set('currentViewerPerms', permission, { silent: false });

            if ('World' === selectedUser || 'Everyone' === selectedUser) {
                $(`select[name='permissions'] option[value='${selectedUser}']`).attr('selected', 'selected');
            } else {
                $(`select[name='permissions'] option[id='${selectedUserId}']`).attr('selected', 'selected');
            }

            (() => {
                const isEitherFullControlChecked
                    = $(`#${fullControlIdPrefix}allow`).prop('checked')
                    || $(`#${fullControlIdPrefix}deny`).prop('checked');
                PermissionsDetailView.disableNormalRows(isEitherFullControlChecked, isReport);
            })();

            PermissionsDetailView.conditionWorldPermUI(selectedUser, permission.length);
        });
    }

    addPermission(ev) {
        ev.preventDefault();
        //Add timeout to allow the spinner to show
        this.Spinner.spin($(constants.CONTENT_ID).get(0));
        setTimeout( () => {
            restService.browseAllUsers().then(usersData => {
                 console.log("The users data", usersData);
    
                const users = ( ud => {
                    let userAccum = [];
                    userAccum.push( PermissionsDetailView.createUserSpecialItem('World') );
                    userAccum.push( PermissionsDetailView.createUserSpecialItem('Everyone') );
    
                    if (ud.AllUsers.User) {
                        userAccum = _.union(userAccum, util.enforceArrayType(usersData.AllUsers.User));
                    }
                    return userAccum;
                })(usersData);
    
                // console.log("new users", users);
                const items = users.map( item => {
                    return {
                        id: item['@id'],
                        label: item['@caption'],
                        listType: item['@type'],
                        items: item
                    }
                });
                
                const isReport =  false;
    
                // PF-5852 added param infiniteScrolling to allow list to use it
                const permissionView = new SelectItemModalView({ model: new Model({items: items, width: 375, infiniteScrolling: constants.INFINITE_SCROLL_ENABLED}), spinner: this.Spinner });
                   
              permissionView.render().then(selectedItem => {
                  
                     if (selectedItem) {
                     
                        const currentPermissionList = this.model.get('currentPermissionList');
                        const permissionsChanged = currentPermissionList.filter((permission)=> {
                            return permission['@id'] === selectedItem.items['@id']
                                && permission['@caption'] === selectedItem.items['@caption'];
                        });
    
                        if (permissionsChanged.length === 0) {
    
                            const newItem = _.cloneDeep( PermissionsDetailView.createPermissionForItem( selectedItem, isReport ));
                            currentPermissionList.push(newItem);
    
                            this.model.set(
                                {
                                    'hasChanges': true,
                                    'currentPermissionList': currentPermissionList
                                }, {silent: false});
    
                               this.fillPermissions();
                            const
                                viewerId = selectedItem.items['@id'],
                                viewerName = selectedItem.items['@caption'];
                            PermissionsDetailView.selectPermissionViewer( viewerId, viewerName );
    
                        }

                        
                    }
            
                }).catch((errMsg) => {
                    console.log(errMsg);
                    notificationService.error(errMsg);
                });
            });
        }, 100);
        
    }

    removePermission(ev){
        ev.preventDefault();
        const
            $row = $(`select[name='permissions']`),
            selectedUser = $row.val(),
            selectedUserId = $row.children(':selected').attr('id'),
            isWorldOrEveryone = 'World' === selectedUser || 'Everyone' === selectedUser;

        const currentPermissionList = this.model.get('currentPermissionList');
        const currentPermissionListWithRemovedElement = currentPermissionList.filter( user => isWorldOrEveryone
                ? user['@caption'] !== selectedUser
                : user['@id'] !== selectedUserId  );

        if(currentPermissionListWithRemovedElement.length < currentPermissionList.length) {

            this.model.set(
                {
                    'hasChanges': true, 'currentPermissionList': currentPermissionListWithRemovedElement,
                    'selectedViewer': '',
                    'selectedViewerId': ''
                }, {silent: true});

            this.fillPermissions();

            window.setTimeout( () => PermissionsDetailView.clearPermPanel(constants.FORMS_PERMISSION_ITEM_COUNT), 0);
        }
    }

    formatPermissionsForResponse(permissions) {

        let isNoUsers = false;
        const bufferStr = permissions.reduce((accum, elem) => {

            const defaultId = (!(elem['@type'] === 'world' || elem['@type'] === 'everyone'))
                ? ` id="${elem['@id']}" `
                : ` id="-2147483524" `;

            let perms = accum + `<User ${defaultId} type="${elem['@type']}"  caption="${elem['@caption']}"> `;

            // Notice that each Permission value is emitted as the Permission XML element value, not an XML attribute
            util.enforceArrayType(elem.Permission).forEach(p => {
                if (p) {
                    perms += `<Permission type="${p['@type']}">${p['#text']}</Permission>`;
                } else {
                    isNoUsers = true;
                }

            });

            if (!isNoUsers) {
                perms += `</User>`;
            }
            return perms;

        }, '');

        const noUsers = `<Permissions><User  id="-2147483524"  type="world"  caption="World"> <Permission type="view">deny</Permission></User></Permissions>`;

        const permissionList = isNoUsers ? noUsers : `<Permissions>${bufferStr}</Permissions>`;

        console.log('CurrentSendPermissions before encoding', permissionList);

        const encodedPermissionList = permissionList.replace(/</g, '&lt;').replace(/>/g, '&gt;');

        return encodedPermissionList;
    }

    fillPermissions(){
        $(`select[name='permissions']`).html("");
        this.model.get('currentPermissionList').forEach( permission => {
            $(`select[name='permissions']`).append($("<option></option>")
                .attr('id', permission['@id'])
                .attr('value', permission['@caption'])
                .text(permission['@caption']));
        });
    }

   
    persistData(type){

        const saveChanges = ()=>{
            // Saving Changes
            const id = this.model.get('formId') || this.model.get('reportId');
            const currentPermissionList = this.model.get('currentPermissionList');
            const currentPermissionsToSend = this.formatPermissionsForResponse(currentPermissionList);
            const name = this.model.get('formName') || this.model.get('reportName');
            const isActive = this.model.get('isActive');
            const mobileFormIsActive = this.model.get('mobileFormIsActive');
            const notificationRequiresLogin = this.model.get('notificationRequiresLogin');

            if (type === "app") {
                restService.updateForm(id, name, isActive, mobileFormIsActive, notificationRequiresLogin, currentPermissionsToSend).then(data => {
                }, err => {
                    console.log(`persistData updateForm: ${restMessages.codeToMessage(err.CODE)}`);
                });
            }
            else {
                restService.updateReport(id, name, isActive, currentPermissionsToSend).then(data => {
                }, err => {
                    console.log(`persistData updateForm: ${restMessages.codeToMessage(err.CODE)}`);
                });
            }
        }

        PermissionsDetailView.validateChanges(
            util.isTrue(this.model.get('IsPrivate')),
            this.model.get('currentPermissionList'),
            saveChanges, this);
    }

    render(type){
        return new Promise((resolve, reject) => {

            const settings = this.settings;
            settings.width = 400;
            settings.buttons = [
                {
                    text: 'OK',
                    click: () => {
                        this.persistData(type);
                        this.closeModal("#permissions-modal");
                       
                    }
                },
                {
                    text: 'Cancel',
                    click: () => {
                        this.closeModal("#permissions-modal");
                    }
                }
            ];

            settings.open = () => {
             
            };

            this.model.set('isReport', type === "report", {silent: true});
            let currentRequireLoginFromEmail = util.isTrue(this.model.get('currentRequireLoginFromEmail'));
            $(`input[name='currentRequireLoginFromEmail']`).prop('checked', currentRequireLoginFromEmail );


            if(this.template) {
                this.$el.html(this.template(this.model.toJSON()));
            }
            super.render("#permissions-modal");

           
            this.fillPermissions();

            if (!util.isTrue( this.model.get('IsPrivate') )) {
                this.model.set('currentViewerPerms', {}, {silent: true});
                this.model.set('selectedViewer', '', {silent:true});
            
              
                $('#sharedPermissions').removeClass('hide');

                this.permsDetailView = new PermissionsDetailView({model: this.model, el: '#sharedPermissions', 'isReport': false});
                this.permsDetailView.render();
            }

            this.bindEvents();
        });
    }

}

export default PermissionsModal;